import { RcClasses } from '../../../foundation';
export var RcBackdropClasses = RcClasses(['root'], 'RcBackdrop');
